var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 10 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.532 3.943v2.512H.687V9.56h1.845v9.22h3.857V9.56h2.597s.253-1.506.338-3.104H6.389V4.281c0-.338.422-.753.837-.753h2.098V.339h-2.85c-4.027 0-3.942 3.104-3.942 3.604Z",
    fill: "currentColor"
  })));
};

export { SvgFacebook as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxMCAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIuNTMxNTQgMy45NDI2OFY2LjQ1NTE5SDAuNjg3NVY5LjU1OTMzSDIuNTMxNTRWMTguNzc5Nkg2LjM4ODY3VjkuNTU5MzNIOC45ODU3QzguOTg1NyA5LjU1OTMzIDkuMjM5MjUgOC4wNTMzNiA5LjMyMzc3IDYuNDU1MTlINi4zODg2N1Y0LjI4MDc2QzYuMzg4NjcgMy45NDI2OCA2LjgxMTI2IDMuNTI3NzcgNy4yMjYxNyAzLjUyNzc3SDkuMzIzNzdWMC4zMzkxMTFINi40NzMxOUMyLjQ0NzAzIDAuMzM5MTExIDIuNTMxNTQgMy40NDMyNSAyLjUzMTU0IDMuOTQyNjhaIiBmaWxsPSIjN0Q3RDdEIi8+Cjwvc3ZnPgo=";